export default __webpack_public_path__ + "media/images/ui-icons_777777_256x240-f5d5fce2f36b5776eab8b314efc2dfd8.png";